<template>
  <div
    id="dashboard-analytics-fournisseur"
    class="vs-con-loading__container"
    ref="dashboard_analytics"
  >
    <div class="vx-row" ref="welcomeMessgeDiv">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>

          <h1
            class="mb-6 text-white"
            v-if="nouveauFournisseur"
          >Bonjour {{ checkpointReward.userName }}</h1>
          <p
            class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
            v-if="nouveauFournisseur"
          >Bienvenue sur cogepha Live .</p>
          <div v-if="initialmessage">
            <h1 class="mb-4 text-white">Bonjour {{ checkpointReward.userName }},</h1>
            <strong
              class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
            >Bienvenue sur cogepha Live.</strong>
          </div>
        </vx-card>
      </div>
      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Objectif d'achat" class>
          <template slot="actions">
            <vs-dropdown>
              <a class="flex items-center" href="#">
                Actions
                <i class="material-icons">expand_more</i>
              </a>

              <vs-dropdown-menu>
                <vs-dropdown-item>Historique</vs-dropdown-item>

                <vs-dropdown-item @click="onupdateObjectif=true">Modifier</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                <div class="w-full mt-1">
                  <label class="block text-gray-700 text-sm font-bold">Objectif</label>

                  <div class="mt-2">
                    <vs-input :readonly="! onupdateObjectif && objectif.value!=''"
                      class="w-full"
                      v-model="objectif.value"
                      icon-pack="feather"
                      icon="icon-info"
                    />
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full bg-grid-color h-12 px-2 ">
                <div class="w-full mt-1">
                  <label class="block text-gray-700 text-sm font-bold">Periode</label>

                  <div class="mt-2">
                    <v-select
                      class="w-full"
                      v-model="objectif.periode"
                      :options="objectifPeriodOptions"
                    />

                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('tva')"
                    >{{ errors.first('tva') }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                <div class="w-full mt-10 ml-32">
                   <vs-button v-if="onupdateObjectif"
                type="filled"
                @click.prevent="nouveauObjectif()"
                class="sm:float-center ml-2"
              >Enregister</vs-button>
                </div>
              </div>
            
          </form>
        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Statistique D'achat">
                  <apexchart type="bar" height="350" :options="columnChart1.chartOptions" :series="columnChart1.series"></apexchart>

        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Evolution Objectif/Chiffre d'affaire" >
          <template slot="actions"></template>
          <div slot="no-body">
           <apexchart type="radialBar" :options="chartOptions" :series="series" class=" md:pb-24 lg:pb-12"></apexchart>

          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-base">
        <vx-card title="Taux de Rupture">
          <div class="items-center">
            <h1 class="text-center tauxText text-blue2">11 %</h1>
            <strong
              class="text-center m-5"
            >TR= nombre de produits non disponibles/ nombre total de produits</strong>
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-base">
        <vx-card title="Taux d’Obsolescence">
          <div class="items-center">
            <h1 class="text-center tauxText text-grey">88 %</h1>
            <strong
              class="text-center m-5"
            >TO=nombre d’articles non mouvementés pendant 3 mois / nombre total d’articles</strong>
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/3 w-full mb-base">
        <vx-card title="Taux de service">
          <div class="items-center">
            <h1 class="text-center tauxText text-blue1">45 %</h1>
            <strong
              class="text-center m-5"
            >TS= nombre de commandes non honorées /nombre total de commandes</strong>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base">
        <vx-card title="Statistiques des ventes mensuelles globales">
         <apexchart type="bar" height="350" :options="columnChart1.chartOptions" :series="columnChart1.series"></apexchart>

        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="TOP5 d’articles les plus vendus">
          <apexchart type="bar" height="350" :options="columnChart.chartOptions" :series="columnChart.series"></apexchart>

        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Articles à faible rotation">
         <apexchart type="bar" height="350" :options="columnChart.chartOptions" :series="columnChart.series"></apexchart>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base">
        <sale-purchase-per-magasin />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import vSelect from "vue-select";
import _ from "lodash"; 
import SalePurchasePerMagasin from "./SalePurchasePerMagasin.vue";
import fournisseurService from "@/http/requests/fournisseur/index.js";
export default {
  name: "fourAct",
  data() {
    return {


 series: [76],
            chartOptions: {
                chart: {
                    type: "radialBar",
                    offsetY: -20,
                    sparkline: {
                        enabled: true,
                        
                    },
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: "97%",
                            margin: 5, // margin is in pixels
                            dropShadow: {
                                enabled: true,
                                top: 2,
                                left: 0,
                                color: "#999",
                                opacity: 1,
                                blur: 2,
                            },
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                offsetY: -2,
                                fontSize: "22px",
                            },
                        },
                    },
                },
                grid: {
                    padding: {
                        top: -10,
                    },
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "light",
                        shadeIntensity: 0.4,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 53, 91],
                    },
                },
                labels: ["Average Results"],
            },

columnChart1: {
                series: [{
                    name: 'Achat en 2019',
                    data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 55, 11, 77]
                }, {
                    name: 'Achat en 2020',
                    data: [76, 85, 101, 98, 87, 105, 91, 114]
                }, ],
                chartOptions: {
                    colors: this.themeColors,
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nou', 'Dec'],
                    },
                    yaxis: {
                        title: {
                            text: 'en Mille Dinars'
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return  val + "Mille Dinars"
                            }
                        }
                    }
                }
            },

 themeColors: ['#28C76F', '#7367F0', '#EA5455', '#FF9F43', '#1E1E1E'],
            columnChart: {
                series: [{
                    name: 'Achat en 2019',
                    data: [120]
                }, {
                    name: 'Achat en 2019',
                    data: [0, 100]
                }, {
                    name: 'Achat en 2019',
                    data: [0,0, 98]
                }, {
                    name: 'Achat en 2019',
                    data: [0,0,0, 55]
                }, {
                    name: 'Achat en 2019',
                    data: [0,0,0,0, 30]
                }, ],
                chartOptions: {
                    colors: ['#28C76F', '#7367F0', '#EA5455', '#FF9F43', '#1E1E1E'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: ['Aug', 'Sep', 'Oct', 'Nou', 'Dec'],
                    },
                    yaxis: {
                        title: {
                            text: 'Article'
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val + "Mille Dinars"
                            }
                        }
                    }
                }
            },


      periode: this.$store.state.fournisseur.periode,
      selectedyear: this.$store.state.fournisseur.selectedyear,
      nouveauFournisseur: false, //n'est pas encore de donne dans le bdd
      initialmessage: true,
      showadata: false,
      dataupdateKey: 0,
      objectifPeriodOptions: [
        {
          id: "1",
          label: "Mensuels",
        },
        {
          id: "2",
          label: "Trimestriel ",
        },
        {
          id: "3",
          label: "Annuels",
        },
      ],
      checkpointReward: {
        userName: "ADWYA",
      },
      objectif: {},
      histObjectif: [],
      onupdateObjectif :false ,
    };
  },
  computed :{
    
  },
  methods: {
    loadObectif() {
     
    },
    nouveauObjectif() {
      this.objectif.valeur = this.objectif.value;
      this.objectif.periode = this.objectif.periode.label;
      fournisseurService
        .nouveauObjectif(
          this.objectif,
          this.$store.state.AppActiveUser.vendorNo
        )
        .then((response) => {
          this.onupdateObjctif=false
          console.log(response);
        })
        .catch((error) => console.log(error));
    },
    openLoadingInDiv(refernces) {
      this.$vs.loading({
        color: "#7d0c3f",
        container: refernces,
        scale: 0.6,
        type: "radius",
      });
    },
    closeLoadingDiv(refernces) {
      this.$vs.loading.close(refernces);
    },
    onChangeyear(event) {
      (this.selectedyear = event.target.value),
        this.$store.dispatch(
          "fournisseur/UPDATE_PERIODE_YEAR",
          event.target.value
        );
    },
    onChangetrimestre(event) {
      this.periode = event.target.value;
      this.$store.dispatch("fournisseur/UPDATE_PERIODE", event.target.value);
    },
    compareMonth(a, b) {
      let months = [
        "JANV",
        "FÉVR",
        "MARS",
        "AVRI",
        "MAI ",
        "JUIN",
        "JUIL",
        "AOÛT",
        "SEPT",
        "OCTO",
        "NOVE",
        "DÉCE",
      ];
      if (a.substring(5, 9) == b.substring(5, 9)) {
        if (
          months.indexOf(a.substring(0, 4)) < months.indexOf(b.substring(0, 4))
        )
          return false;
        else if (
          months.indexOf(a.substring(0, 4)) > months.indexOf(b.substring(0, 4))
        )
          return true;
        else return true;
      } else if (a.substring(5, 9) < b.substring(5, 9)) return false;
      else return true;
    },
    setLigne1Data() {
      let lastMonth = "JANV";
      let d = new Date().getFullYear();
      let d1 = d - 1;
      let unionMonth = [
        "JANV",
        "FÉVR",
        "MARS",
        "AVRI",
        "MAI ",
        "JUIN",
        "JUIL",
        "AOÛT",
        "SEPT",
        "OCTO",
        "NOVE",
        "DÉCE",
      ];
      let SumAmount = _.mapValues(
        _.groupBy(
          this.$store.state.fournisseur.articles.filter(
            (e) => e.Entry_Type == "Sale"
          ),
          "Month"
        ),
        (clist) =>
          clist.map((item) =>
            _.pick(item, [
              "Vendor_Name",
              "Month",
              "Year",
              "Sales_Amount_Actual",
              "Sales_Amount_Expected",
            ])
          )
      );
      let SumAmountArray = Object.values(SumAmount);
      SumAmount = SumAmountArray;
      lastMonth = _.last(
        SumAmount.filter((item) => item[0].Year == d).sort((a, b) => {
          return this.compareMonth(a[0].Month, b[0].Month);
        })
      );
      var i = 0;
      for (i = 0; i < SumAmountArray.length; i++) {
        var localsum = 0;
        let j = 0;
        for (j = 0; j < SumAmountArray[i].length; j++) {
          localsum +=
            parseFloat(SumAmountArray[i][j].Sales_Amount_Actual) +
            parseFloat(SumAmountArray[i][j].Sales_Amount_Expected);
        }
        if (SumAmountArray[i][0].Year == d) {
          this.cogephaSelesSum.series[0].data[
            unionMonth.indexOf(SumAmountArray[i][0].Month.substring(0, 4))
          ] = localsum.toFixed(3);
          this.cogephaSelesSum.analyticsData.totalVente += parseFloat(localsum);
        } else if (
          lastMonth != null &&
          this.compareMonth(
            lastMonth[0].Month.replace(d, d1), // avoir seulement le mois inf a le mois actuel
            SumAmountArray[i][0].Month
          )
        ) {
          this.cogephaSelesSum_1.series[0].data[
            unionMonth.indexOf(SumAmountArray[i][0].Month.substring(0, 4))
          ] = localsum.toFixed(1);
          this.cogephaSelesSum_1.analyticsData.totalVente += parseFloat(
            localsum
          );
        }
      }
      this.checkpointReward.progress =
        (this.cogephaSelesSum.analyticsData.totalVente /
          this.cogephaSelesSum_1.analyticsData.totalVente) *
          100 -
        100;
      this.checkpointReward.progress = this.checkpointReward.progress.toFixed(
        1
      );
      for (i = 0; i < this.cogephaSelesSum_1.series[0].data.length; i++)
        if (this.cogephaSelesSum_1.series[0].data[i] == null)
          this.cogephaSelesSum_1.series[0].data[i] = 0;
      this.cogephaSelesSum_1.analyticsData.totalVente = this.cogephaSelesSum_1.analyticsData.totalVente.toFixed(
        1
      );
      this.cogephaSelesSum.analyticsData.totalVente = this.cogephaSelesSum.analyticsData.totalVente.toFixed(
        1
      );
      if (
        // lire le nom du fournisseur s'il existe
        this.$store.state.fournisseur.articles != null &&
        this.$store.state.fournisseur.articles.length > 0
      )
        this.checkpointReward.userName = this.$store.state.fournisseur.articles[0].Vendor_Name;
      if (lastMonth != null) {
        this.cogephaSelesSum.statisticTitle =
          "EV_" + d + " jusqu'a la mois " + lastMonth[0].Month.substring(0, 4);
        this.cogephaSelesSum_1.statisticTitle =
          "EV_" + d1 + " jusqu'a la mois " + lastMonth[0].Month.substring(0, 4);
      } else {
        this.cogephaSelesSum.statisticTitle =
          "EV_" + d + " jusqu'a la mois " + unionMonth[new Date().getMonth()];
        this.cogephaSelesSum_1.statisticTitle =
          "EV_" + d1 + " jusqu'a la mois " + unionMonth[new Date().getMonth()];
      }
      if (
        this.cogephaSelesSum.analyticsData.totalVente == "0.0" &&
        this.cogephaSelesSum_1.analyticsData.totalVente == "0.0"
      )
        this.nouveauFournisseur = true;
      this.initialmessage = false;
      this.closeLoadingDiv(this.$refs.dashboard_analytics);
      this.showadata = true;
      this.dataupdateKey += 1;
    },
  },
  created() {
    if (this.$store.state.AppActiveUser.id != "0")  ;
    else {
        this.$store.subscribe((mutation) => {
        if (mutation.type === "UPDATE_USER_INFO") {
          
        }
      });
    }
    if (
      this.$store.state.fournisseur.articles != null &&
      this.$store.state.fournisseur.articles.length > 0
    )
      this.setLigne1Data();
    else
      this.$store.subscribe((mutation) => {
        if (mutation.type === "fournisseur/UPDATE_ARTICLE") {
          this.setLigne1Data();
        }
      });
  },
  mounted() {
    /*  if (
          this.$store.state.fournisseur.articles == null ||
          this.$store.state.fournisseur.articles.length == 0
        )
          this.openLoadingInDiv(this.$refs.dashboard_analytics); */
  },
  components: {
    apexchart: VueApexCharts,
    vSelect,
    
    SalePurchasePerMagasin,
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
.tauxText {
  font-size: 120px;
  letter-spacing: -3px;
}
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>